import { NotificationService } from '@aiz-gl/omni-ui';
import {
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

export function messageInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const notifications = inject(NotificationService);

  const handleStatusCode = (event: HttpResponse<unknown>, status: number) => {
    switch (status) {
      /* Globally handle message-only responses */
      case 200: {
        const message = (event.body as { message?: string })?.message;

        if (typeof message === 'string')
          notifications.showSnackbar({ message });
        break;
      }
      /* No Records found assumed. Messaging now gets handled at the component level.
      case 204: {
        notifications.showAlert({
          message: 'Data unavailable.',
          symbolName: 'file_download_off',
        });
      }*/
    }
  };

  return next(req).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse && event.status) {
        handleStatusCode(event, event.status);
      }
    }),
  );
}
